import { useCallback, useMemo } from 'react'

import { useQuery } from '@shared/modules/use-query/hooks'
import { UseQueryOptions } from '@shared/modules/use-query/types'

import { DepartmentsService } from '../services'
import { Department } from '../types'
import { localURLMaker } from '@shared/utils/url-maker'
import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate'
import { message } from 'antd'

export const useDepartmentDetails = (id?: string | number) => {
  const navigate = useBackgroundNavigate()

  const { data, loading } = useQuery<Department>(
    useCallback(async () => {
      const result = await DepartmentsService.getOneById(id as string)

      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, [id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: null,
        enabled: !!id,
      }),
      [id],
    ),
  )

  const edit = useCallback(() => {
    if (!id) {
      message.error('Şöbə kodu mövcud deyil')
      return
    }
    navigate(localURLMaker('/departments/:id/update', { id }), { withBackground: true })
  }, [navigate, id])

  return { data, loading, edit }
}
